import AlygloIntroduction from './Alyglo';
import CoagadexIntroduction from './Coagadex';
import CutaquigIntroduction from './Cutaquig';
import FactorforhealthIntroduction from './Factorforhealth';
import FibrygaIntroduction from './Fibryga';
import GammakedIntroduction from './Gammaked';
import GammaplexIntroduction from './Gammaplex';
import GamunexIntroduction from './Gamunex';
import KoateIntroduction from './Koate';
import NuwiqIntroduction from './Nuwiq';
import OctagamIntroduction from './Octagam';
import PanzygaIntroduction from './Panzyga';
import ProlastinIntroduction from './Prolastin';
import RyplazimIntroduction from './Ryplazim';
import WilateIntroduction from './Wilate';
import XembifyIntroduction from './Xembify';

const MEDICINE_COMPONENTS = {
  gamunex: GamunexIntroduction,
  gammaplex: GammaplexIntroduction,
  coagadex: CoagadexIntroduction,
  gammaked: GammakedIntroduction,
  koate: KoateIntroduction,
  ryplazim: RyplazimIntroduction,
  prolastin: ProlastinIntroduction,
  alphanine: FactorforhealthIntroduction,
  xembify: XembifyIntroduction,
  alyglo: AlygloIntroduction,
  cutaquig: CutaquigIntroduction,
  octagam: OctagamIntroduction,
  panzyga: PanzygaIntroduction,
  fibryga: FibrygaIntroduction,
  nuwiq: NuwiqIntroduction,
  wilate: WilateIntroduction,
};

const MedicineIntroduction = () => {
  const { name } = JSON.parse(localStorage.getItem('Program') || '{}') || {};
  const Component = MEDICINE_COMPONENTS[name as keyof typeof MEDICINE_COMPONENTS];
  return Component ? (
    <div data-testid="isi-section" className="mt-10">
      <Component />
    </div>
  ) : null;
};

export default MedicineIntroduction;
